import { gql } from 'graphql-tag';
export const activeStudentsAndTeachersList = gql `
    query activeStudentsAndTeachersList {
        activeStudentsAndTeachersList {
            students {
                weekStartDate
                newUserCount
                returningUserCount
            }
            teachers {
                weekStartDate
                newUserCount
                returningUserCount
            }
        }
    }
`;
